export type ProfileTaskPermissions = {
    readonly canComment: boolean;
    readonly canEdit: boolean;
    readonly canRead: boolean;
};

export const resolveProfileTaskPermissions = ({
    hasStagedChanges,
    isParentEditing,
    isPersisted,
    parentCanEdit,
    parentCanRead,
}: {
    readonly hasStagedChanges: boolean;
    readonly isParentEditing: boolean;
    readonly isPersisted: boolean;
    readonly parentCanEdit: boolean;
    readonly parentCanRead: boolean;
}): ProfileTaskPermissions => ({
    canComment: parentCanRead && isPersisted && !hasStagedChanges && !isParentEditing,
    canEdit: parentCanRead && parentCanEdit && isParentEditing,
    canRead: parentCanRead,
});
